export const getTableButtonText = (order) => {
  if (order.status === 'sold') {
    return 'confirm';
  }
  if (order.status === 'seller_confirmed') {
    return 'issue gen. label';
  }
  if (order.status === 'seller_packaging' && order.shippingLabel) {
    return 'print label';
  } else if (order.status === 'seller_packaging') {
    return 'generating label';
  }
};
